import { useState } from 'react';
import ModalWrapper from 'components/common/overlays/ModalWrapper';
import SingleBtn from 'components/common/elements/SingleBtn';
import styles from 'styles/components/common/overlays/Modal.module.scss';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import useModal from 'hooks/useModal';

type TProps = {
  isError?: boolean;
  chartRound: number | undefined;
  patientName: string;
  chartCount: number;
  onConfirm: (password: string) => void;
};

const ChangePatient = ({
  isError = false,
  chartRound,
  patientName,
  chartCount,
  onConfirm,
}: TProps) => {
  const { closeModal } = useModal();

  const [password, setPassword] = useState<string>('');

  return (
    <ModalWrapper>
      <header className={styles.title_wrapper}>
        <h2 className={styles.title}>이미 다른 대상자가 등록되어 있습니다.</h2>
        <button type="button" onClick={closeModal}>
          <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
        </button>
      </header>
      <p className="mt10 mb16 lh27 fs18 fw700">대상자를 변경하시겠습니까?</p>
      <ul className={styles.text_box}>
        <li>
          {chartRound || '동일 '}회차에 {patientName || '다른'} 대상자로{' '}
          {chartCount && `${chartCount}개의`} 차트가 등록되어 있습니다.
        </li>
        <li>
          대상자 변경 시 기존에 등록된 차트는 모두 삭제되고 데이터 복구가
          불가합니다.
        </li>
        <li>대상자 변경에 동의하시면 비밀번호를 입력해 주세요.</li>
      </ul>
      <input
        type="password"
        name="password"
        placeholder="비밀번호를 입력해 주세요."
        style={{
          width: '100%',
          height: '48px',
          border: `1px solid ${
            STYLES_VARIABLES[isError ? 'RED_01' : 'GRAY_05']
          }`,
          borderRadius: '8px',
          padding: '0 24px',
          marginTop: '20px',
        }}
        onChange={(e) => setPassword(e.target.value)}
      />
      {isError && (
        <p className="error_text">
          비밀번호가 일치하지 않습니다. 다시 입력해 주세요.
        </p>
      )}
      <footer className="modal_btn_wrapper mt24">
        <SingleBtn
          btnText="취소"
          hasOutline={true}
          btnStyle={{
            width: '100%',
            fontSize: '14px',
          }}
          onClick={closeModal}
        />
        <SingleBtn
          btnText="확인"
          isBtnActive={true}
          btnStyle={{
            width: '100%',
            fontSize: '14px',
          }}
          disabled={!password}
          onClick={() => onConfirm(password)}
        />
      </footer>
    </ModalWrapper>
  );
};

export default ChangePatient;
